import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#0F62FE",
      d: "M12.038 20q-3.14 0-5.32-2.18-2.18-2.178-2.18-5.318t2.18-5.321Q8.898 5 12.038 5q1.755 0 3.32.78a7.1 7.1 0 0 1 2.603 2.2V5h1.5v6.115h-6.115v-1.5h3.95a5.9 5.9 0 0 0-2.193-2.281 5.9 5.9 0 0 0-3.065-.834q-2.5 0-4.25 1.75t-1.75 4.25 1.75 4.25 4.25 1.75a5.86 5.86 0 0 0 3.475-1.1 5.8 5.8 0 0 0 2.175-2.9h1.58q-.68 2.448-2.68 3.974Q14.585 20 12.037 20"
    }, null, -1)
  ])))
}
export default { render: render }